module.exports = __webpack_public_path__ + "media/images/game_icon/zh-tw/AB1531-48b575dadf5973f58b3f75321e4ee28b.png";